import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as Material from '@angular/material';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  imports: [
    CommonModule,
    Material.MatToolbarModule,
    Material.MatInputModule,
    Material.MatIconModule,
    Material.MatButtonModule,
    Material.MatCheckboxModule,
    Material.MatSelectModule,
    Material.MatNativeDateModule,
    Material.MatDatepickerModule,
    Material.MatTableModule,
    Material.MatPaginatorModule,
    Material.MatSortModule,
    Material.MatTooltipModule,
    Material.MatSnackBarModule,
    Material.MatSlideToggleModule,
    Material.MatDialogModule,
    Material.MatStepperModule,
    Material.MatProgressSpinnerModule,
    Material.MatSidenavModule,
  ],
  exports: [
    Material.MatToolbarModule,
    Material.MatInputModule,
    Material.MatIconModule,
    Material.MatButtonModule,
    Material.MatCheckboxModule,
    Material.MatSelectModule,
    Material.MatNativeDateModule,
    Material.MatDatepickerModule,
    Material.MatTableModule,
    Material.MatPaginatorModule,
    Material.MatSortModule,
    Material.MatTooltipModule,
    Material.MatSnackBarModule,
    Material.MatSlideToggleModule,
    Material.MatDialogModule,
    Material.MatStepperModule,
    Material.MatProgressSpinnerModule,
    Material.MatSidenavModule,
    DragDropModule,
  ]
})
export class MaterialModule { }
